<template>
  <transition name="fade-b">
    <div
      v-if="show"
      class="fixed left-0 bottom-0 w-full z-400 p-2 flex-c flex-wrap bg-black text-white text-center"
      role="dialog"
    >
      <p
        v-if="messageText || (pageLinkText && pageLinkHref)"
        class="mx-4 my-2"
      >
        <span
          v-if="messageText"
          v-html="messageText"
        />
        <a
          v-if="pageLinkText && pageLinkHref"
          :href="pageLinkHref"
          class="ml-2 inline-flex underline focus:no-underline lg:hover:no-underline"
          role="button"
          target="_blank"
          rel="noopener"
          v-html="pageLinkText"
        />
      </p>
      <button
        v-if="closeBtnText"
        class="mx-4 my-2 cursor-pointer px-12 py-2 bg-black border-2 border-solid border-white transition-colors duration-500 ease-in-out focus:bg-white lg:hover:bg-white focus:text-black lg:hover:text-black"
        v-html="closeBtnText"
        @click="dismiss"
      />
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CookieConsent',

  data: () => ({
    // Default data
    message: 'This website uses cookies to ensure you get the best experience.',
    linkLabel: 'Learn more',
    linkHref: 'https://www.cookiesandyou.com',
    buttonLabel: 'Got it!',
    defaultCookieName: 'cookieconsent_status_acknowledged',
    cookiePath: '/',
    cookieDomain: '',
    cookieExpiryDays: 365,
    // Interaction
    show: undefined
  }),

  computed: {
    // Store
    ...mapState([ 'options' ]),
    // Text
    messageText() { return this.options.cookie_message || this.message },
    pageLinkText() { return this.options.cookie_page_link_text || this.linkLabel },
    pageLinkHref() { return this.options.cookie_page_link_href || this.linkHref },
    closeBtnText() { return this.options.cookie_message_close_button_text || this.buttonLabel },
    cookieName() { return this.options.cookie_name || this.defaultCookieName },
    // Functional
    cookie() { return this.getCookie(this.cookieName) },
  },

  beforeMount() {
    this.show = !this.cookie
  },

  methods: {
    dismiss() {
      this.show = false
      this.setCookie(this.cookieName, 1, this.cookieExpiryDays, this.cookieDomain, this.cookiePath)
    },
    getCookie(name) {
      const value = `; ${document.cookie}`
      const parts = value.split(`; ${name}=`)
      return parts.length !== 2 ? undefined : parts.pop().split(';').shift()
    },
    setCookie(name, value, expiryDays, domain, path) {
      const exdate = new Date()
      exdate.setDate(exdate.getDate() + (expiryDays || 365))
      const cookie = [
        `${name}=${value}`,
        `expires=${exdate.toUTCString()}`,
        `path=${path || '/'}`
      ]
      if (domain) { cookie.push(`domain=${domain}`) }
      document.cookie = cookie.join(';')
    }
  }
}
</script>
